module.exports = __webpack_public_path__ + "./fonts/Rubik_300Light_Italic.ttf";